export default __webpack_public_path__ + "static/media/new-layout.09088fc9.png";